import { IFeatureGroupBase } from '../../models/features';
import { IVentureBase } from '../../models/ventures';
import {
  IUserAssignmentBase,
  IUserBase,
  IUserOnboardBase,
} from '../../models/users';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';
import IListResponse from '../../utils/list-response';

interface IListUserProps {
  cpf?: string;
  email?: string;
  experience?: number;
  featureGroups?: Array<string>;
  hostId?: string;
  ignoreFeatureGroups?: Array<string>;
  isBlockedOrSuspended?: boolean;
  assignmentStatus?: 'ACTIVE' | 'DELETED' | 'ALL';
  scheduleExperience?: number;
  name?: string;
  phone?: string;
  ventureId?: string;
  sort?: 'cpf' | 'name' | 'phone' | 'email' | 'createdAt';
  order?: 'ASC' | 'DESC';
  limit?: number;
  page?: number;
}

interface IUserAssignment extends IUserAssignmentBase {
  featureGroup: IFeatureGroupBase;
  venture?: IVentureBase;
}

interface IUserEffectiveRestriction {
  blockedUntil?: string | null;
  isBlocked: boolean;
  source: 'SELF' | 'HOST' | 'TITULAR';
  sourceUserId: string;
  sourceUserName?: string;
}

export interface IUserListItem extends IUserBase {
  effectiveRestriction?: IUserEffectiveRestriction;
  onboards: IUserOnboardBase[];
  userAssignments: IUserAssignment[];
}

export type IUserList = IListResponse<IUserListItem>;

export const listUsersService = async (
  filters?: IListUserProps,
): Promise<IUserList> => {
  const params =
    filters && Object.keys(filters).length !== 0
      ? {
          cpf: filters.cpf || undefined,
          email: filters.email || undefined,
          featureGroups: filters.featureGroups || undefined,
          hostId: filters.hostId || undefined,
          ignoreFeatureGroups: filters.ignoreFeatureGroups || undefined,
          isBlockedOrSuspended: filters.isBlockedOrSuspended || undefined,
          assignmentStatus: filters.assignmentStatus || undefined,
          experience: filters.experience,
          minExperience: filters.scheduleExperience,
          name: filters.name || undefined,
          phone: filters.phone || undefined,
          ventureId: filters.ventureId || undefined,
          sort: filters.sort,
          order: filters.order,
          limit: filters.limit,
          page: filters.page,
        }
      : undefined;

  const { data } = await jhsfBookingsApi.get<IUserList>('/users', { params });

  return data;
};
